import { useState, useEffect } from 'react';
import { fetchFilesInformation } from 'src/store/Profile/profile.slice';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { PersonalInformationContainer, Banner } from './phoneConfirmation.styles';
import Card from 'src/utilities/UILibrary/UI/Card/Card';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { InputField } from 'src/utilities/UILibrary/Forms/InputField/InputField';
import ConfirmOnboardingModal from 'src/components/shared/modals/onboardingSuccess/onboardingSuccess';
import { errorHandler } from 'src/middlewares/Auth/index.utilities';
import ModalError from 'src/components/shared/modals/Error/Error';
import { useManageSteps } from 'src/hooks/useManageSteps';
import { environment, url } from 'src/environments';
import { setLoadingState } from 'src/store/User/user.slice';
import { useNavigate } from 'react-router-dom';

export default function PhoneConfirmation() {
  const [step, setStep] = useState(1);
  const [referenceId, setReferenceId] = useState('');
  const [mobilephone, setMobilephone] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showFinishedModal, setShowFinishedModal] = useState(false);
  const [numberINE, setNumberINE] = useState('');
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const { nextStep } = useManageSteps();
  const navigate = useNavigate();

  useEffect(() => {
    if (user.id) {
      dispatch(fetchFilesInformation(user.id)).then((action) => {
        if (fetchFilesInformation.fulfilled.match(action)) {
          const documentNumber = action.payload.data?.getFile.INE.documentNumber;
          setNumberINE(documentNumber || '');
        }
      });
    }
  }, [user.id, dispatch]);

  const resetInputs = () => {
    setStep(1);
    setMobilephone('');
    setVerificationCode('');
  };

  const handleGetCode = async (event) => {
    event.preventDefault();
    const mobileP = mobilephone.split(' ')[0] + mobilephone.split(' ')[1];
    const input = {
      id: user.id,
      typeOfUser: 'investor'
    };

    let efisys = {
      typeOperation: 'NR',
      registrationType: 'CO',
      bmxActivity: '0100008',
      ocupationNumber: '34',
      registrationMotive: '3',
      tipoCliente: 'investor',
      clienteId: user.id,
      idNumber: numberINE
    };
    if (user.typeOfPerson === 'MORAL') {
      efisys.notaryName = 'N/A';
      efisys.notaryNumber = '006';
      efisys.inscriptionReg = 'N/A';
      efisys.publicDeed = 'N/A';
      efisys.foundationDate = '1990-04-01';
    }
    const trully = {
      id: user.id,
      typeOfUser: 'investor',
      phone: mobileP
    };
    await axios.post(`${url}/${environment}/efysis/customer/customer-registration`, efisys);
    const trullyTwo = await axios.post(
      `${url}/${environment}/trully/enrich-data/predict/second-step`,
      trully
    );
    const body = JSON.parse(trullyTwo.data.body);
    const label = body.label;
    if (label === 'No Threat') {
      //Ejecuta lambda para enviar código de verificación
      const phone = await axios.post(
        `${url}/${environment}/admin/mobile/${mobileP}/get-otp`,
        input
      );
      const parsedBody = JSON.parse(phone.data.body);
      const referenceId = parsedBody.ReferenceId;
      setReferenceId(referenceId);
      setStep(2);
    }
    navigate('/inversionista/validation-page');
  };

  const handleValidateCode = async (event) => {
    event.preventDefault();
    const mobileP = mobilephone.split(' ')[0] + mobilephone.split(' ')[1];
    const body = {
      id: user.id,
      otp: verificationCode,
      referenceId: referenceId,
      typeOfUser: 'investor'
    };

    dispatch(setLoadingState(true));
    const response = await axios.post(
      ` ${url}/${environment}/admin/mobile/${mobileP}/validate-otp`,
      body
    );
    const parsedBody = JSON.parse(response.data.body);
    const codeResponse = parsedBody.isVerified;

    if (codeResponse === true) {
      dispatch(setLoadingState(false));
      await nextStep();
      setShowFinishedModal(true);
    } else {
      dispatch(setLoadingState(false));
      errorHandler(dispatch, { code: 'incorrectPhoneCode' });
      console.error('Incorrect verification code.');
    }
  };

  return (
    <PersonalInformationContainer>
      <ModalError onReset={resetInputs} />
      <ConfirmOnboardingModal
        showModal={showFinishedModal}
        onClose={() => (window.location.href = '/inversionista/dashboard')}
        typeOfUser="investor"
      />
      <Banner>
        <figure>
          <img
            src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_inv_personalInformation6_banner.png`}
            alt="Finsphera configuración de seguridad"
          />
        </figure>
        <h2>Configuración de seguridad</h2>
      </Banner>
      <Card isSlim className="card-container">
        <p>
          {step === 1
            ? 'Tu seguridad es lo más importante, por eso es fundamental que mantengas actualizado tu número de celular. Proporciónanos tu teléfono celular a 10 dígitos:'
            : 'Ingresa el código de verificación que enviamos a tu número celular'}
        </p>
        <form onSubmit={step === 1 ? handleGetCode : handleValidateCode}>
          <InputField
            isDialCode
            value={mobilephone}
            onChangeInternalValue={(value) => setMobilephone(value)}
            placeholder="Número de teléfono"
            minLength={10}
            required
          />
          {step === 2 && (
            <>
              <InputField
                value={verificationCode}
                onChangeInternalValue={(value) => setVerificationCode(value)}
                type="number"
                regex={/^\d{1,6}$/}
                restrictRegex
                errorRegexMessage="El código de verificación debe ser de 6 dígitos"
                placeholder="Código de verificación"
                required
              />
              <Button isFullWidth size="small" type="submit">
                Validar código de verificación
              </Button>
            </>
          )}
          {step === 1 && (
            <Button isFullWidth size="small" type="submit">
              Enviar código de verificación
            </Button>
          )}
        </form>
      </Card>
    </PersonalInformationContainer>
  );
}
